/**
 * @desc getSupplierSkuCanDeliveryQty
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.SupplierSkuDeliverableResponseRpcDto>>;
export function request(
  body: Array<defs.tms.CabinSkuDetailDataResponseDtoReq>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMaster/getSupplierSkuCanDeliveryQty`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
